import {Howl} from "howler";
import ringtoneSound from "./res/sounds/ringtones/1.mp3";

const RINGTONE = new Howl({
  src: [ringtoneSound],
  loop: true,
});

export function playRingtone(): void {
  RINGTONE.play();
}

export function stopRingtone(): void {
  RINGTONE.stop();
}